<div class="guest-price-summary respos-ft-light" *ngFor="let itemPrice of priceDetail.Items">
    <div class="guest-price-summary--label">{{itemPrice.Name}}</div>
    <div class="guest-price-summary--value">{{currency}}{{itemPrice.SubTotal | currencyDecimalFormatter}}</div>
</div>
<div class="guest-price-summary__seperator"></div>
<ng-container *ngFor="let labelMap of paymentSplitKeyLabels">
    <div class="guest-price-summary respos-ft-light" *ngIf="priceDetail[labelMap.key]">
        <div class="guest-price-summary--label">{{labelMap.label | translate}}</div>
        <div class="guest-price-summary--value">{{currency}}{{priceDetail[labelMap.key] | currencyDecimalFormatter}}</div>
    </div>
</ng-container>
<div class="guest-price-summary__seperator"></div>
<div class="guest-price-summary respos-ft-light guest-price-summary--bold">
    <div class="guest-price-summary--label">{{'Total'}}</div>
    <div class="guest-price-summary--value">{{currency}}{{priceDetail.Total | currencyDecimalFormatter}}</div>
</div>